$(document).ready(function () {
  let ceArray = document.querySelectorAll(".loadOnScroll");
  loadOnScroll();

  window.addEventListener('scroll', loadOnScroll);
  function loadOnScroll() {
    for (let i = 0; i < ceArray.length; i++) {
      let elem = ceArray[i]
      let ceBounding = elem.getBoundingClientRect().top - window.innerHeight + 50;
      if (ceBounding < 0) {
        elem.classList.add("inView");
      }
    }
  }
})

